import _find from 'lodash/find';

import affiliateService from 'api/affiliate';
import cityService from 'api/city';
import venueService from 'api/venue';
import config from 'src/config';

const STRIPE_REDIRECT_URI = config.NODE_ENV === 'production' ? 'https://affiliate.tablelist.com/oauthcallback/stripe' : 'https://affiliate-dev.tablelist.com/oauthcallback/stripe';
const STRIPE_CONNECT_URL = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${config.STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${STRIPE_REDIRECT_URI}`;

function Ctrl($scope, $rootScope, $q, modalService, alertService, $stateParams) {
  $scope.loading = false;

  const stripeUserId = $stateParams.stripeUserId;

  $scope.saving = false;
  $scope.saveResult = null;
  $scope.saveBtnOptions = {
    buttonInitialIcon: 'icon-left fa fa-image',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Save',
    buttonSubmittingText: 'Saving...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Saved',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error',
    buttonErrorClass: 'animated-button-error'
  };

  $scope.save = function(form) {
    $scope.saving = true;

    if (form.$invalid) {
      $scope.saving = false;
      $scope.saveResult = 'error';
      return null;
    }

    return $q.resolve(affiliateService.updateById($scope.affiliate.id, {
        membershipName: $scope.settingsForm.membershipName,
        membershipCities: $scope.settingsForm.membershipCities,
        membershipVenues: $scope.settingsForm.membershipVenues
      }))
      .then(response => {
        $scope.user = response;
        $scope.saving = false;
        $scope.saveResult = 'success';

        alertService.success('Saved');
      })
      .catch(err => {
        console.log('err', err);
        $scope.errorMsg = err.data.errors[0].message;
        $scope.saving = false;
        $scope.saveResult = 'error';
      });
  };

  $scope.connectStripe = function($event) {
    $event.preventDefault();

    window.location.href = STRIPE_CONNECT_URL;
  };

  $scope.disconnectStripe = function($event) {
    $event.preventDefault();

    let modalInstance;

    modalService.confirmation({
        modalHeader: 'Disconnect Stripe',
        modalMessage: 'Are you sure you want to disconnect your Stripe account?',
        confirmBtnTxt: 'Disconnect',
        confirmingBtnTxt: 'Disconnecting...',
        size: 'md'
      })
      .then(result => {
        modalInstance = result.modalInstance;

        if (result && result.confirm) {
          return $q.resolve(affiliateService.updateById($scope.affiliate.id, {
              paymentProviderAccountId: null
            }))
            .then(affiliate => {
              $scope.affiliate = affiliate;

              alertService.success('Stripe account disconnected');
            });
        }

        return null;
      })
      .finally(() => modalInstance.close());
  };

  $scope.loading = true;

  $scope.getVenues = function(search) {
    return $q.resolve(venueService.listByAffiliateId($scope.affiliate.id, {
        search,
        enable: true,
        sort: 'name',
        limit: 10
      }))
      .then(results => {
        $scope.venues = results;
      });
  };

  $q.all([
      $q.resolve(cityService.list()),
      $q.resolve(venueService.listByAffiliateId($scope.affiliate.id, {
        id: $scope.affiliate.membershipVenues,
        limit: $scope.affiliate.membershipVenues.length || 1
      }))
    ])
    .then(results => {
      $scope.cities = results[0];
      $scope.venues = results[1];

      $scope.settingsForm = {
        membershipName: $scope.affiliate.membershipName,
        membershipCities: $scope.affiliate.membershipCities.map(id => {
          return _find($scope.cities, {
            id
          });
        }),
        membershipVenues: $scope.affiliate.membershipVenues.map(id => {
          return _find($scope.venues, {
            id
          });
        })
      };

      if (stripeUserId) {
        $scope.loading = true;

        return $q.resolve(affiliateService.updateById($scope.affiliate.id, {
            paymentProviderAccountId: stripeUserId
          }))
          .then(updatedAffiliate => {
            $rootScope.affiliate = updatedAffiliate;

            alertService.success('Stripe account connected');

            $scope.loading = false;
          });
      }

      $scope.loading = false;

      return null;
    });
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$q',
  'modalService',
  'alertService',
  '$stateParams'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/settings/settingsCtrl.js